import React from "react";
import RpAutocomplete from "./RpAutocomplete";

export default function RpFormikAutocomplete({
  field,
  form: { touched, errors, setFieldValue },
  onChange: externalOnChange,
  ...rest
}) {
  const errorText =
    touched[field.name] && errors[field.name] ? errors[field.name] : "";

  return (
    <RpAutocomplete
      {...rest}
      name={field.name}
      value={field.value}
      error={!!errorText}
      helperText={errorText}
      onBlur={field.onBlur}
      onChange={(newValue) => {
        setFieldValue(field.name, newValue);
        externalOnChange?.(newValue);
      }}
    />
  );
}
